export default __webpack_public_path__ + "static/media/screen10.7aa0dc76.svg";